import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/people',
        component: () => import('../views/People.vue')
    },
    {
        path: '/projects',
        component: () => import(/* webpackChunkName: "projects" */'../views/Projects.vue'),
    },
    {
        path: '/projects/categories',
        component: () => import(/* webpackChunkName: "projects" */'../views/ProjectCategory.vue')
    },
    {
        path: "/projects/categories/project",
        component: () => import(/* webpackChunkName: "projects" */'../views/projectTemplate.vue')
    },
    {
        path: '/publications',
        component: () => import('../views/Publication.vue')
    },
    {
        path: '/copyright',
        component: () => import('../views/Copyright.vue')
    },
    {
        path: '/reference',
        component: () => import('../views/Reference.vue')
    },
    {
        path: "/projects/categories/whatis",
        component: () => import(/* webpackChunkName: "special-projects" */'../views/SpecialProject/Whatis.vue')
    },
    {
        path: "/projects/categories/whatif", // Old url with typo
        redirect: "/projects/categories/whatis",
    },
    {
        path: "/recentPress",
        component: () => import('../views/RecentPress.vue')
    },
    {
        path: "/repository",
        name: 'Repository',
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository.vue')
    },
    {
        path: "/repository/AutoScene",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/AutoScene.vue')
    },
    {
        path: "/repository/COIL-20",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/COIL20.vue')
    },
    // UrbanSky Routes - START
    {
        path: "/repository/UrbanSky",
        name: 'UrbanSkyAbout',
        component: () => import(/* webpackChunkName: "repository-urbansky" */'../views/Repository/UrbanSky/About.vue'),
        meta: {
            title: 'UrbanSky - About'
        }
    },
    {
        path: "/repository/UrbanSky/explore",
        name: 'UrbanSkyExplore',
        component: () => import(/* webpackChunkName: "repository-urbansky" */'../views/Repository/UrbanSky/Explore.vue'),
        meta: {
            title: 'UrbanSky - Explore'
        }
    },
    {
        path: "/repository/UrbanSky/acquisition",
        name: 'UrbanSkyAcquisition',
        component: () => import(/* webpackChunkName: "repository-urbansky" */'../views/Repository/UrbanSky/Acquisition.vue'),
        meta: {
            title: 'UrbanSky - Acquisition'
        }
    },
    {
        path: "/repository/UrbanSky/download",
        name: 'UrbanSkyDownload',
        component: () => import(/* webpackChunkName: "repository-urbansky" */'../views/Repository/UrbanSky/Download.vue'),
        meta: {
            title: 'UrbanSky - Download'
        }
    },
    {
        path: "/repository/UrbanSky/acknowledgements",
        name: 'UrbanSkyAcknowledgements',
        component: () => import(/* webpackChunkName: "repository-urbansky" */'../views/Repository/UrbanSky/Acknowledgements.vue'),
        meta: {
            title: 'UrbanSky - Acknowledgements'
        }
    },
    {
        path: "/repository/COIL-100",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/COIL100.vue')
    },
    {
        path: "/repository/ColumbiaGazeDataSet",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/ColumbiaGaze.vue')
    },
    {
        path: "/repository/Contaminants",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Contaminants/main.vue')
    },
    {
        path: "/repository/DoRF",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/DoRF.vue')
    },
    {
        path: "/repository/EDGEVA",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/EDGEVA.vue')
    },
    {
        path: "/repository/FaceTracer",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/FaceTracer.vue')
    },
    {
        path: "/repository/LSD",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/LSD.vue')
    },
    {
        path: "/repository/NEARSEARCH",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/NEARSEARCH.vue')
    },
    {
        path: "/repository/RAFA",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/RAFA.vue')
    },
    {
        path: "/repository/Rain",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Rain.vue')
    },
    {
        path: "/repository/SLAM",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/SLAM.vue')
    },
    {
        path: "/repository/Splash",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Splash.vue')
    },
    {
        path: "/repository/VisualEyes",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/VisualEyes/main.vue')
    },
    {
        path: "/repository/VisualEyes/Tutorial",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/VisualEyes/tutorial.vue')
    },
    {
        path: "/repository/Contaminants/about",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Contaminants/about.vue')
    },
    {
        path: "/repository/Contaminants/scattering",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Contaminants/scattering.vue')
    },
    {
        path: "/repository/Contaminants/source",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Contaminants/source.vue')
    },
    {
        path: "/repository/Contaminants/texture",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Contaminants/texture.vue')
    },
    {
        path: "/repository/WILD",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/main.vue')
    },
    {
        path: "/repository/WILD/about",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/about.vue')
    },
    {
        path: "/repository/WILD/copyright",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/copyright.vue')
    },
    {
        path: "/repository/WILD/images",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/images.vue')
    },
    {
        path: "/repository/WILD/download",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/download.vue')
    },
    {
        path: "/repository/WILD/searchengine",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/searchengine.vue')
    },
    {
        path: "/repository/WILD/sponsor",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/sponsor.vue')
    }, {
        path: "/repository/WILD/videos",
        component: () => import(/* webpackChunkName: "repository-wild" */'../views/Repository/WILD/videos.vue')
    },
    {
        path: "/repository/CURET",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/main.vue')
    },
    {
        path: "/repository/CURET/about",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/about.vue')
    },
    {
        path: "/repository/CURET/sample",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/sample.vue')
    },
    {
        path: "/repository/CURET/btfm",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/BTFM.vue')
    },
    {
        path: "/repository/CURET/brdfm",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/BRDFM.vue')
    },
    {
        path: "/repository/CURET/brdfp",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/BRDFP.vue')
    },
    {
        path: "/repository/CURET/download",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/download.vue')
    },
    {
        path: "/repository/CURET/document",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/documentation.vue')
    },
    {
        path: "/repository/CURET/txtmap",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/textonly.vue')
    },
    {
        path: "/repository/CURET/graphmap",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/graphonly.vue')
    },
    {
        path: "/repository/CURET/table",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/table.vue')
    },
    {
        path: "/repository/CURET/cal",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/cal.vue')
    },
    {
        path: "/repository/CURET/cly",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/cly.vue')
    },
    {
        path: "/repository/CURET/spheres",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/spheres.vue')
    },
    {
        path: "/repository/CURET/spheres3",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/spheres3.vue')
    },
    {
        path: "/repository/CURET/spheres5",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/spheres5.vue')
    },
    {
        path: "/repository/CURET/spheres55",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/spheres55.vue')
    },
    {
        path: "/repository/CURET/over",
        component: () => import(/* webpackChunkName: "repository-curet" */'../views/Repository/CURET/over.vue')
    },
    {
        path: "/repository/PubFig",
        component: () => import(/* webpackChunkName: "repository-pubfig" */'../views/Repository/Pubfig/main.vue')
    },
    {
        path: "/repository/PubFig/download",
        component: () => import(/* webpackChunkName: "repository-pubfig" */'../views/Repository/Pubfig/download.vue')
    },
    {
        path: "/repository/PubFig/explore",
        component: () => import(/* webpackChunkName: "repository-pubfig" */'../views/Repository/Pubfig/explore.vue')
    },
    {
        path: "/repository/PubFig/results",
        component: () => import(/* webpackChunkName: "repository-pubfig" */'../views/Repository/Pubfig/result.vue')
    },
    {
        path: "/repository/RASCAL",
        component: () => import(/* webpackChunkName: "repository-rascal" */'../views/Repository/RASCAL/main.vue')
    },
    {
        path: "/repository/RASCAL/about",
        component: () => import(/* webpackChunkName: "repository-rascal" */'../views/Repository/RASCAL/about.vue')
    },
    {
        path: "/repository/RASCAL/software",
        component: () => import(/* webpackChunkName: "repository-rascal" */'../views/Repository/RASCAL/software.vue')
    },
    {
        path: "/repository/RASCAL/gallery",
        component: () => import(/* webpackChunkName: "repository-rascal" */'../views/Repository/RASCAL/gallery.vue')
    },
    {
        path: "/repository/STAF",
        component: () => import(/* webpackChunkName: "repository-staf" */'../views/Repository/STAF/main.vue')
    },
    {
        path: "/repository/STAF/about",
        component: () => import(/* webpackChunkName: "repository-staf" */'../views/Repository/STAF/about.vue')
    },
    {
        path: "/repository/STAF/db",
        component: () => import(/* webpackChunkName: "repository-staf" */'../views/Repository/STAF/db.vue')
    },
    {
        path: "/repository/STAF/documentation",
        component: () => import(/* webpackChunkName: "repository-staf" */'../views/Repository/STAF/documentation.vue')
    },
    {
        path: "/repository/STAF/samples",
        component: () => import(/* webpackChunkName: "repository-staf" */'../views/Repository/STAF/samples.vue')
    },
    {
        path: "/repository/TVBRDF",
        component: () => import(/* webpackChunkName: "repository-tvbrdf" */'../views/Repository/TVBRDF/main.vue')
    },
    {
        path: "/repository/TVBRDF/about",
        component: () => import(/* webpackChunkName: "repository-tvbrdf" */'../views/Repository/TVBRDF/about.vue')
    },
    {
        path: "/repository/TVBRDF/measures",
        component: () => import(/* webpackChunkName: "repository-tvbrdf" */'../views/Repository/TVBRDF/MandP.vue')
    },
    {
        path: "/repository/TVBRDF/documentation",
        component: () => import(/* webpackChunkName: "repository-tvbrdf" */'../views/Repository/TVBRDF/documentation.vue')
    }, {
        path: "/repository/TVBRDF/download",
        component: () => import(/* webpackChunkName: "repository-tvbrdf" */'../views/Repository/TVBRDF/download.vue')
    },
    {
        path: "/projects/categories/gigapixel",
        component: () => import(/* webpackChunkName: "repository" */"../views/SpecialProject/gigapixel.vue")
    },
    {
        path: "/gallery/FibonacciHDR",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/FibonacciHDR/main.vue")
    },
    {
        path: "/gallery/Diffuse_sl/main",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/Diffuse_sl/main.vue")
    },
    {
        path: "/gallery/Diffuse_sl/pos1",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/Diffuse_sl/pos1.vue")
    },
    {
        path: "/gallery/Diffuse_sl/pos2",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/Diffuse_sl/pos2.vue")
    },
    {
        path: "/gallery/Diffuse_sl/gsr",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/Diffuse_sl/gsr.vue")
    },
    {
        path: "/gallery/Diffuse_sl/qa",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/Diffuse_sl/qa.vue")
    },
    {
        path: "/gallery/separation/main",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/main.vue")
    },
    {
        path: "/gallery/separation/DGSB",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/DiffuseGroove.vue")
    },
    {
        path: "/gallery/separation/RWO",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/WorldObjects.vue")
    },
    {
        path: "/gallery/separation/PFF",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/PlantsFlowersFood.vue")
    },
    {
        path: "/gallery/separation/SH",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/SkinHair.vue")
    },
    {
        path: "/gallery/separation/PSS",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/photometric.vue")
    },
    {
        path: "/gallery/separation/SO",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/Occluders.vue")
    },
    {
        path: "/gallery/separation/BTF",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/BTF.vue")
    },
    {
        path: "/gallery/separation/SS",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/SeparationScales.vue")
    },
    {
        path: "/gallery/separation/RF",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/RealFake.vue")
    },
    {
        path: "/gallery/separation/VRS",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/SeparationResult/VRS.vue")
    },
    {
        path: "/gallery/micro_phase_shifting",
        component: () => import(/* webpackChunkName: "gallery" */"../views/Gallery/MicroPhaseShift/main.vue")
    },
    {
        path: "/repository/Multispectral",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Multispectral/main.vue')
    },
    {
        path: "/repository/Multispectral/Stuff",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Multispectral/Stuff.vue')
    },
    {
        path: "/repository/Multispectral/Paints",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Multispectral/Paints.vue')
    },
    {
        path: "/repository/Multispectral/RealandFake",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Multispectral/RealAndFake.vue')
    },
    {
        path: "/repository/Multispectral/SkinAndHair",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Multispectral/SkinAndHair.vue')
    },
    {
        path: "/repository/Multispectral/FoodAndDrinks",
        component: () => import(/* webpackChunkName: "repository" */'../views/Repository/Multispectral/FoodAndDrinks.vue')
    },
    {
        path: "/gallery/flexible_dof",
        component: () => import(/* webpackChunkName: "gallery" */'../views/Gallery/Flexible_DOF.vue')
    },
    // Matador Routes - START
    {
        path: "/repository/Matador",
        name: 'MatadorAbout',
        component: () => import(/* webpackChunkName: "repository-matador" */'../views/Repository/Matador/About.vue'),
        meta: {
            title: 'Matador - About'
        }
    },
    {
        path: "/repository/Matador/acquisition",
        name: 'MatadorAcquisition',
        component: () => import(/* webpackChunkName: "repository-matador" */'../views/Repository/Matador/Acquisition.vue'),
        meta: {
            title: 'Matador - Acquisition'
        }
    },
    {
        path: "/repository/Matador/downloads",
        name: 'MatadorDownloads',
        component: () => import(/* webpackChunkName: "repository-matador" */'../views/Repository/Matador/Downloads.vue'),
        meta: {
            title: 'Matador - Downloads'
        }
    },
    {
        path: "/repository/Matador/acknowledgements",
        name: 'MatadorAcknowledgements',
        component: () => import(/* webpackChunkName: "repository-matador" */'../views/Repository/Matador/Acknowledgements.vue'),
        meta: {
            title: 'Matador - Acknowledgements'
        }
    },
    {
        path: "/:catchAll(.*)",
        component: () => import("../views/Home.vue")
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    scrollBehavior() {
        // always scroll to top
        return { top: 0 }
    },
    routes
})

export default router
